"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGroupedBlockType = exports.addHash = exports.getHash = exports.getTintBlendModeByLabel = exports.getBlockSpacingValue = exports.getSplashBlockMinHeightValue = exports.getBlockWidthValue = void 0;
var lodash_1 = require("lodash");
var es_toolkit_1 = require("es-toolkit");
var object_hash_1 = __importDefault(require("object-hash"));
var blockSpacingMappings_1 = __importDefault(require("./BlockConfig/blockSpacingMappings"));
var blockWidthMappings_1 = __importDefault(require("./BlockConfig/blockWidthMappings"));
var commonTypes_1 = require("./BlockConfig/commonTypes");
var splashConfig_1 = require("./BlockConfig/splashConfig");
var BlockStyleTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/BlockStyleTypes");
var mobx_1 = require("mobx");
var colord_1 = require("colord");
var getBlockWidthValue = function (optionLabel) {
    if (optionLabel) {
        return blockWidthMappings_1.default[optionLabel];
    }
};
exports.getBlockWidthValue = getBlockWidthValue;
var getSplashBlockMinHeightValue = function (blockSpacing) {
    if (blockSpacing) {
        if (typeof blockSpacing === "object") {
            return splashConfig_1.minHeightOptions[commonTypes_1.OptionLabelTypes.Medium];
        }
        return splashConfig_1.minHeightOptions[blockSpacing];
    }
};
exports.getSplashBlockMinHeightValue = getSplashBlockMinHeightValue;
var getBlockSpacingValue = function (blockSpacing) {
    if (blockSpacing) {
        if (typeof blockSpacing === "object") {
            return "".concat(blockSpacing.before, "%");
        }
        return blockSpacingMappings_1.default[blockSpacing];
    }
};
exports.getBlockSpacingValue = getBlockSpacingValue;
var getTintBlendModeByLabel = function (label) {
    var blendMode = splashConfig_1.tintBlendModeOptions.find(function (config) { return config.label === label; });
    return !!blendMode ? blendMode.value : "blend";
};
exports.getTintBlendModeByLabel = getTintBlendModeByLabel;
function makeHashableStyle(style) {
    var e_1, _a, e_2, _b, e_3, _c;
    var copy = (0, lodash_1.cloneDeep)((0, mobx_1.toJS)(style));
    var widgets = ["accordion", "button", "roiCalculator", "table"];
    try {
        for (var widgets_1 = __values(widgets), widgets_1_1 = widgets_1.next(); !widgets_1_1.done; widgets_1_1 = widgets_1.next()) {
            var widget = widgets_1_1.value;
            delete copy[widget];
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (widgets_1_1 && !widgets_1_1.done && (_a = widgets_1.return)) _a.call(widgets_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var excluded = ["account", "name", "hash", "_id", "clonedFrom", "preTcdcRef", "__v", "textSize"];
    try {
        for (var excluded_1 = __values(excluded), excluded_1_1 = excluded_1.next(); !excluded_1_1.done; excluded_1_1 = excluded_1.next()) {
            var k = excluded_1_1.value;
            delete copy[k];
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (excluded_1_1 && !excluded_1_1.done && (_b = excluded_1.return)) _b.call(excluded_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    delete copy["isMigrated"];
    delete copy["migratedAt"];
    delete copy["legacyBlockType"];
    if (copy["css"] === "") {
        delete copy["css"];
    }
    var bg = copy["background"];
    if (bg && bg.url === undefined) {
        delete bg.url;
    }
    if (bg && bg.videoThumbnail === undefined) {
        delete bg.videoThumbnail;
    }
    var oldStyleKeys = new Set([
        "background",
        "animation",
        "blockWidth",
        "blockSpacing",
        "css",
        "h1",
        "h2",
        "p",
        "blockQuote",
        "list",
        "link",
        "button",
        "accordion",
        "roicalculator",
        "table",
        "textSize",
        "alignment",
        "backgroundCard",
        "tintBlendMode",
        "acceptButton",
        "uiHighlightColor",
        "headerSection",
        "quoteBackgroundOn",
        "blockHeight",
        "name",
    ]);
    try {
        for (var _d = __values((0, BlockStyleTypes_1.extractAssignableStyleKeys)(style).filter(function (s) { return !oldStyleKeys.has(s); })), _e = _d.next(); !_e.done; _e = _d.next()) {
            var k = _e.value;
            if (copy[k] !== undefined)
                continue;
            delete copy[k];
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return clearEmptyObjects(copy);
}
function normalizeColor(value) {
    if (!(0, es_toolkit_1.isString)(value))
        return value;
    if (value === "constructor")
        return value;
    if (value === "__proto__")
        return value;
    if (!(0, colord_1.colord)(value).isValid())
        return value;
    var c = (0, colord_1.colord)(value);
    var _a = c.rgba, r = _a.r, g = _a.g, b = _a.b, a = _a.a;
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
}
var getHash = function (style) {
    var firstHash = (0, object_hash_1.default)(makeHashableStyle(style), {
        algorithm: "sha1",
        replacer: normalizeColor,
    });
    if ((0, BlockStyleTypes_1.isSourceStyle)(style)) {
        return (0, object_hash_1.default)({
            first: firstHash,
            h1: undefined,
            h2: undefined,
            p: undefined,
            blockQuote: undefined,
        });
    }
    else {
        return (0, object_hash_1.default)({
            first: firstHash,
            h1: style.h1 && style.h1.size && style.h1.size.abs,
            h2: style.h2 && style.h2.size && style.h2.size.abs,
            p: style.p && style.p.size && style.p.size.abs,
            blockQuote: style.blockQuote && style.blockQuote.size.abs,
        });
    }
};
exports.getHash = getHash;
var addHash = function (style) {
    style.hash = (0, exports.getHash)(style);
    return style;
};
exports.addHash = addHash;
var getGroupedBlockType = function (blockType) {
    return [commonTypes_1.BlockType.Source, commonTypes_1.BlockType.Splash, commonTypes_1.BlockType.Accept, commonTypes_1.BlockType.Quote].includes(blockType)
        ? blockType
        : commonTypes_1.BlockType.Text;
};
exports.getGroupedBlockType = getGroupedBlockType;
var clearEmptyObjects = function (o) {
    for (var k in o) {
        if (!o[k] || typeof o[k] !== "object") {
            continue;
        }
        clearEmptyObjects(o[k]);
        if (Object.keys(o[k]).length === 0) {
            delete o[k];
        }
    }
    return o;
};
